import { PageLayout, Content } from "core/layouts";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { BaasicButton, BaasicModal } from "core/components";
import { defaultTemplate } from "core/hoc";
import {
    DressingBoxTemplate,
    AdditionalValidationModalTemplate,
    ApplicationTypeValidationTemplate,
    ValidationModalTemplate
} from "../components";
class WoundOrderAddWoundDressingTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            selectedValue: null,
        };
    }

    render() {
        const { woundOrderAddWoundDressingViewStore } = this.props;
        const {
            contentLoading,
            setSelectedTabItem,
            woundItems,
            selectedWound,
            onEdit,
            checkDuplicateDressingTypes,
            boxes,
            addNewWound,
            isEditingDressing,
            deleteWound,
            checkEligiblity,
            additionalValidationModal,
            validationModal,
            applicationTypeValidationModal,
            showSummary,
            orderInfo,
            showProceedToDispensingOrderButton,
            goToDispensingOrderPage,
            validationModalIsOpen,
            downloadReport
        } = woundOrderAddWoundDressingViewStore;

        const woundTabButtons = [
            ...(woundItems
                ? woundItems.map((item) => (
                    <BaasicButton
                        key={item.id}
                        icon={
                            item.hasPassedAdditionalChecks
                                ? "u-icon u-icon--sml u-icon--active"
                                : null
                        }
                        className={
                            "tabs--facility__item " +
                            (item.id === selectedWound.id ? "active" : "")
                        }
                        label={" " + item.location}
                        onClick={() =>
                            item.id !==
                                (selectedWound.id ||
                                    item.location === "New Wound")
                                ? setSelectedTabItem("woundLocation", item)
                                : {}
                        }
                    />
                ))
                : []),

            !showSummary && (
                <BaasicButton
                    key="add-new-wound"
                    className="tabs--facility__item add-new-wound"
                    label={null}
                    icon="u-icon u-icon--lrg u-icon--add-lined"
                    onClick={() => addNewWound()}
                />
            ),
        ];

        return (
            <PageLayout store={woundOrderAddWoundDressingViewStore}>
                <h2 className="u-mar--bottom--sml">
                    {orderInfo}
                </h2>
                <div className="btn--progress-bar__wrapper">
                    <BaasicButton
                        label="Wound Details"
                        className={`btn btn--progress-bar${showSummary ? "" : " active"
                            }`}
                        icon="u-icon u-icon--sml btn--progress-bar__icon"
                    />
                    <BaasicButton
                        label="Dispensing Order Review"
                        className="btn btn--progress-bar"
                        icon="u-icon u-icon--sml btn--progress-bar__icon"
                    />
                    <BaasicButton
                        label="Summary"
                        className={`btn btn--progress-bar${showSummary ? " is-completed" : ""
                            }`}
                        icon="u-icon u-icon--sml btn--progress-bar__icon"
                    />
                </div>
                <div className="card card--facility">
                    <Content loading={contentLoading}>
                        <div>
                            <div className="tabs--facility">
                                {woundTabButtons}
                            </div>
                        </div>
                        <div className="card--facility__body">
                            <div className="card--facility__primary">
                                <div className="card--facility__side">
                                    <span className="card--facility__side--title">
                                        Wound details
                                    </span>
                                </div>
                                <div className="card--facility__content">
                                    <div className="card--facility__wrapper">
                                        <table className="card__column-list">
                                            <tr>
                                                <td>Diagnosis Code(s):</td>
                                                <td className="type--color--black type--wgt--bold">
                                                    {selectedWound.diagnosisCodes !=
                                                        ""
                                                        ? selectedWound.diagnosisCodes
                                                        : "N/A"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Length:</td>
                                                <td className="type--color--black type--wgt--bold">
                                                    {selectedWound.length !=
                                                        0 &&
                                                        selectedWound.length != null
                                                        ? `${selectedWound.length} cm`
                                                        : "N/A"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Width:</td>
                                                <td className="type--color--black type--wgt--bold">
                                                    {selectedWound.width != 0 &&
                                                        selectedWound.width != null
                                                        ? `${selectedWound.width} cm`
                                                        : "N/A"}
                                                </td>
                                            </tr>
                                            {selectedWound.etiologyThicknessTypeId != null && 
                                            selectedWound.thicknessType != null && 
                                            <tr>
                                                <td>Thickness Type:</td>
                                                <td className="type--color--black type--wgt--bold">
                                                    {   
                                                        selectedWound.thicknessType.name !=
                                                        "" &&
                                                        selectedWound.thicknessType.name !=
                                                        null
                                                        ? selectedWound.thicknessType.name
                                                        : "N/A"}
                                                </td>
                                            </tr>}
                                            {selectedWound.debridementType != null && 
                                            <tr>
                                                <td>Debridement:</td>
                                                <td className="type--color--black type--wgt--bold">
                                                    {   
                                                        selectedWound.debridementType.name !=
                                                        "" &&
                                                        selectedWound.debridementType.name !=
                                                        null
                                                        ? selectedWound.debridementType.name
                                                        : "N/A"}
                                                </td>
                                            </tr>}
                                            <tr>
                                                <td>Exudate Type:</td>
                                                <td className="type--color--black type--wgt--bold">
                                                    {   selectedWound.exudateType != 
                                                        null &&
                                                        selectedWound.exudateType.name !=
                                                        "" &&
                                                        selectedWound.exudateType.name !=
                                                        null
                                                        ? selectedWound.exudateType.name
                                                        : "N/A"}
                                                </td>
                                            </tr>
                                            {selectedWound.depth != null && 
                                            <tr>
                                                <td>Depth:</td>
                                                <td className="type--color--black type--wgt--bold">
                                                    {   selectedWound.depthUnknownTypeId === 
                                                        null &&
                                                        selectedWound.depth ? `${selectedWound.depth} cm`
                                                        : "N/A"
                                                    }
                                                </td>
                                            </tr>}
                                            {selectedWound.etiologyPressureStageId != null && 
                                            selectedWound.pressureStage != null &&
                                            <tr>
                                                <td>Pressure Stage:</td>
                                                <td className="type--color--black type--wgt--bold">
                                                    {   
                                                        selectedWound.pressureStage.name !=
                                                        "" &&
                                                        selectedWound.pressureStage.name !=
                                                        null
                                                        ? selectedWound.pressureStage.name
                                                        : "N/A"}
                                                </td>
                                            </tr>}
                                        </table>
                                    </div>

                                    {!showSummary && (
                                        <div className="card--facility__options">
                                            <BaasicButton
                                                className="btn btn--icon"
                                                icon="u-icon u-icon--edit u-icon--sml"
                                                label="Edit wound details"
                                                onlyIcon={true}
                                                onClick={() => onEdit()}
                                            ></BaasicButton>
                                            <BaasicButton
                                                className="btn btn--icon u-mar--left--sml"
                                                icon="u-icon u-icon--delete u-icon--sml"
                                                label="Delete wound"
                                                onlyIcon={true}
                                                onClick={() => deleteWound()}
                                            ></BaasicButton>
                                        </div>
                                    )}
                                </div>
                            </div>
                            {boxes.map((box) => (
                                <DressingBoxTemplate
                                    key={box.id}
                                    box={box}
                                    woundOrderAddWoundDressingViewStore={
                                        woundOrderAddWoundDressingViewStore
                                    }
                                />
                            ))}
                        </div>
                        {(!isEditingDressing || showSummary) && (
                            <div className="card--facility__footer">
                                {!selectedWound.hasPassedAdditionalChecks && (
                                    <div className="card--facility__footer--wrapper">
                                        <span className="card--facility__footer--label">
                                            Add dressing:
                                        </span>

                                        <div className="card--facility__footer--btn-group">
                                            <BaasicButton
                                                onClick={() => checkDuplicateDressingTypes("Filler")}
                                                className="btn btn--dressing btn--dressing--filler"
                                                label="Filler"
                                                icon="u-icon u-icon--xmed u-icon--filler--dressing"
                                            />
                                            <BaasicButton
                                                onClick={() =>
                                                    checkDuplicateDressingTypes("Primary")
                                                }
                                                className="btn btn--base btn--dressing btn--dressing--primary"
                                                label="Primary"
                                                icon="u-icon u-icon--xmed u-icon--layer--dressing"
                                            />
                                            <BaasicButton
                                                onClick={() =>
                                                    checkDuplicateDressingTypes("Secondary")
                                                }
                                                className="btn btn--base btn--dressing btn--dressing--secondary"
                                                label="Secondary"
                                                icon="u-icon u-icon--xmed u-icon--layer--secondary"
                                            />
                                            <BaasicButton
                                                onClick={() =>
                                                    checkDuplicateDressingTypes("Tertiary")
                                                }
                                                className="btn btn--base btn--dressing btn--dressing--tertiary"
                                                label="Tertiary"
                                                icon="u-icon u-icon--xmed u-icon--layer--tertiary"
                                            />
                                            <BaasicButton
                                                onClick={() => checkDuplicateDressingTypes("Tape")}
                                                className="btn btn--base btn--dressing btn--dressing--tape"
                                                label="Tape"
                                                icon="u-icon u-icon--xmed u-icon--sticker--dressing"
                                            />
                                        </div>
                                    </div>
                                )}

                                {woundItems.some(item => !item.hasPassedAdditionalChecks) && !selectedWound.hasPassedAdditionalChecks && !validationModalIsOpen && (
                                    <BaasicButton
                                        onClick={() => checkEligiblity()}
                                        className="btn btn--med btn--primary"
                                        label="Begin Review"
                                    />
                                )}

                                {woundItems.every(
                                    (item) =>
                                        item.hasPassedAdditionalChecks === true
                                ) && !showSummary && !showProceedToDispensingOrderButton && (
                                        <BaasicButton
                                            className="btn btn--med btn--primary"
                                            label="Resume Review"
                                            onClick={() => checkEligiblity()}
                                        />
                                    )}

                                {woundItems.every(
                                    (item) =>
                                        item.hasPassedAdditionalChecks === true
                                ) && !showSummary && showProceedToDispensingOrderButton && (
                                        <BaasicButton
                                            className="btn btn--med btn--primary"
                                            label="Open Dispensing Order"
                                            onClick={() => goToDispensingOrderPage()}
                                        />
                                    )}

                                {woundItems.every(
                                    (item) =>
                                        item.hasPassedAdditionalChecks === true
                                ) && showSummary && !showProceedToDispensingOrderButton && (
                                        <BaasicButton
                                            className="btn btn--med btn--primary"
                                            label="Download Report"
                                            onClick={() => downloadReport()}
                                        />
                                    )}

                                <BaasicModal
                                    modalParams={validationModal}
                                    className="modal modal__eligibility">
                                    <ValidationModalTemplate
                                        woundOrderAddWoundDressingViewStore={
                                            woundOrderAddWoundDressingViewStore
                                        }
                                    />
                                </BaasicModal>

                                <BaasicModal
                                    modalParams={additionalValidationModal}
                                    className="modal modal__eligibility">
                                    <AdditionalValidationModalTemplate
                                        woundOrderAddWoundDressingViewStore={
                                            woundOrderAddWoundDressingViewStore
                                        }
                                    />
                                </BaasicModal>

                                <BaasicModal
                                    modalParams={applicationTypeValidationModal}
                                    className="modal modal__eligibility">
                                    <ApplicationTypeValidationTemplate
                                        woundOrderAddWoundDressingViewStore={
                                            woundOrderAddWoundDressingViewStore
                                        } />
                                </BaasicModal>
                            </div>
                        )}
                    </Content>
                </div>
            </PageLayout>
        );
    }
}

WoundOrderAddWoundDressingTemplate.propTypes = {
    woundOrderAddWoundDressingViewStore: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default defaultTemplate(WoundOrderAddWoundDressingTemplate);
